<template>
  <base-button
    size="sm"
    type="warning"
    style="margin: 2px; margin-bottom: 1rem;"
    @click="openGuide"
  >{{ $t('openguide') }}</base-button>
</template>

<script>
export default {
  methods: {
    openGuide() {
      window.open(this.getUrl, '_blank');
    }
  },
  computed: {
    getUrl() {
      return window.location.origin + "/admin/guide";
    }
  },
};
</script>

<i18n>
{
  "en": {
    "openguide": "Facilitator guide (new tab)"
  },
  "fi": {
    "openguide": "Pelinjohtajan ohjeet (uusi tab)"
  },
  "sv": {
    "openguide": "Instruktioner för spelledare (ny flik)"
  },
  "de": {
    "openguide": "Anweisungen für den Moderator (neuen Tab)"   
  },
  "ko": {
    "openguide": "퍼실리테이터 가이드(새 탭에서 열기)"
  }
}
</i18n>
